<template>
  <div class="newsDetail">
    <div class="content">
      <div class="header">
        <p class="title">{{ bean.title }}</p>
        <p class="time">{{ bean.createDate }} ｜ 浏览 {{ bean.browserCount }}</p>
      </div>
      <div class="contentDiv">
        <div style="padding-top:.5rem;">
          <img :data-src="firstPhoto" :src="firstPhoto" style="width:100%;" />
        </div>
        <div class="contentTxt" v-html="bean.content"></div>

        <div class="upd">
          上一篇：
          <a :href="getHref(last.id, category)" class=""> {{ last.title }} </a><br />
          下一篇：
          <a :href="getHref(next.id, category)" class=""> {{ next.title }} </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '../../../common/bus'
export default {
  name: 'newsDetail',
  components: {},
  data() {
    return {
      id: 0,
      category: null,
      firstPhoto: '',
      bean: {
        title: '',
        content: '',
        browserCount: 0,
        createDate: '',
      },
      last: {
        id: '',
        title: '',
      },
      next: {
        id: '',
        title: '',
      },
    }
  },
  mounted(){
    var visited = this.$getVisited('OweDynamic_'+this.id)
    if(visited==1){
      this.$plus('OweDynamic',{id:this.id},['browserCount'])
    }
  },
  created() {
    if (this.$route.params.class == 0) {
      bus.$emit('path', 'xwdt')
    } else if (this.$route.params.class == 1) {
      bus.$emit('path', 'hybk')
    } else if (this.$route.params.class == 2) {
      bus.$emit('path', 'khxz')
    }
    var that = this
    var params = this.$route.params
    this.id = params['id']
    this.category = params['class']
    this.$queryOne('/api/dynamic/queryDynamicOne', { id: this.id }, function(res) {
      that.firstPhoto = res['data'].firstPhoto
      that.$fill(that.bean, res['data'])
      that.$fill(that.last, res['last'])
      that.$fill(that.next, res['next'])
    })
  },
  methods: {
    getHref(id, category) {
      return '/newsDetail/' + category.value + '/' + id
    },
  },
}
</script>

<style>
.newsDetail .content {
  padding: 0.4rem;
}
.newsDetail .upd {
  width: 100%;

  font-size: 0.37333rem;
  margin-top: 0.8rem;
  line-height: 0.53rem;
}
.newsDetail .upd a {
  width: 100%;
  color: #dea767;
  font-size: 0.37333rem;
  margin-top: 0.8rem;
}
.newsDetail .upd .content {
  font-size: 0.37333rem;
  line-height: 0.53rem;
  margin-bottom: 0.27rem;
}
.newsDetail .contentTxt {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  -o-tab-size: 4;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  /* white-space: pre-wrap; */
  word-wrap: break-word;
}
.newsDetail .contentTxt p {
  margin: 0.5rem 0;
  color: #666;
  line-height: 0.7rem;
}
.newsDetail .contentTxt img {
  width: 100%;
}
.newsDetail .header .title {
  font-size: 0.48rem;
  font-weight: 500;
  color: #333;
  line-height: 0.67rem;
  margin-bottom: 0.48rem;
}
.newsDetail .header .time {
  font-size: 0.37333rem;
  color: #999;
  line-height: 0.53rem;
}
</style>
